import { label } from '../services';

const logTypeMap = {
	ACTIVITY: '直播间',
	GATHER: '合集',
	SUB_ACCOUNT: '子账号',
	ORDER: '商城',
	PRODUCT: '商品',
	WITHDRAWAL: '我的资产',
	PHY: '连锁门店',
};

const PayTypeMap = {
	0: '免费版',
	1: '专业版',
	2: '旗舰版',
	3: '尊享版',
	9: '企业版',
};

const userTypeMap = {
	0: '免费版',
	1: '旗舰版',
	2: '尊享版',
	3: '企业版',
};

const payNeedUserTypeMap = {
	0: 0, // 说明需要当前用户为免费版以上
	1: 1, // 说明需要当前用户为旗舰版以上
	2: 1, // 说明需要当前用户为旗舰版以上
	3: 2, // 说明需要当前用户为尊享版以上
	9: 3, // 说明需要当前用户为企业版以上
};

const typeMap = {
	logType: logTypeMap,
	payType: PayTypeMap,
	userType: userTypeMap,
	payNeedUserType: payNeedUserTypeMap,
};
// 通过map的key获取值
export const getValueForkey = (type, code) => {
	if (!type || !typeMap[type]) {
		console.error('没有这个类型的信息');
		return '';
	}
	const map = typeMap[type];
	return map[code];
};
// 通过map的值获取key
export const getKeyForValue = (type, name) => {
	if (!type || !typeMap[type]) {
		console.error('没有这个类型的信息');
		return '';
	}
	const map = typeMap[type];
	return Object.keys(map).find((key) => {
		return map[key] === name;
	});
};
// 获取map对象
export const getMapWithObject = (type) => {
	if (!type || !typeMap[type]) {
		console.error('没有这个类型的内容');
		return '';
	}
	const map = typeMap[type];
	return map;
};
// 获取map对象的值转为数组
export const getArrayWithValue = (type) => {
	if (!type || !typeMap[type]) {
		console.error('没有这个类型的内容');
		return '';
	}
	const map = typeMap[type];
	return Object.keys(map).map((e) => {
		return map[e];
	});
};

// 获取对应的key转为数组
export const getArrayWithKey = (type) => {
	if (!type || !typeMap[type]) {
		console.error('没有这个类型的内容');
		return '';
	}
	const map = typeMap[type];
	return Object.keys(map);
};

// 获取自定义列表
/**
 * @param { String } type map类型
 * @param { String } ObjectOption.key 对应map中key的字段标记
 * @param { String } ObjectOption.value 对应map中value的字段标记
 * @returns
 */
export const getCustomArray = (type, ObjectOption) => {
	if (!type || !typeMap[type]) {
		console.error('没有这个类型的内容');
		return [];
	}
	const map = typeMap[type];
	const { key, value } = ObjectOption;
	if (!key || !value) {
		return map;
	}
	return Object.keys(map).map((e) => {
		let obj = {};
		obj[key] = e;
		obj[value] = map[e];
		return obj;
	});
};

export const roleTree = [
	// {
	// 	label: '创建直播',
	// 	id: 1,
	// },
	// {
	// 	label: '企业概况',
	// 	route: 'user.selfcenter',
	// 	id: 2,
	// },
	{
		label: '直播',
		id: 3,
		route: 'user.liveMode',
		children: [
			{
				label: '我的直播',
				id: 20,
				route: 'user.live',
				children: [
					{
						label: '创建直播',
						id: 23,
						route: '',
					},
				],
			},
			{
				label: '直播合集',
				id: 21,
				route: 'user.myAlbum',
			},
			{
				label: '直播建站',
				id: 22,
				route: 'user.portal',
			},
		],
	},
	{
		label: '媒体库',
		id: 4,
		route: 'user.material',
		children: [
			{
				label: '视频库',
				id: 30,
				route: 'user.material.video',
			},
			{
				label: '素材库',
				id: 31,
				route: 'user.material.source',
			},
			{
				label: '图文直播',
				id: 32,
				route: 'user.material.tuwen',
			},
			{
				label: '直播水印',
				id: 33,
				route: 'user.material.water',
			},
		],
	},
	{
		label: '营销中心',
		id: 5,
		route: 'user.marketing',
	},
	{
		label: '用户中心',
		id: 6,
		route: 'user.userCenter',
		children: [
			// {
			// 	label: '用户管理',
			// 	id: 40,
			// 	route: 'user.userManage',
			// },
			{
				label: '活动通知',
				id: 41,
				route: 'user.eventNotice',
			},
			{
				label: '敏感词汇',
				id: 42,
				route: 'user.sensitive',
			},
			{
				label: '标签管理',
				route: 'user.labelManage',
				id: 43,
			},
			{
				label: '评论管理',
				route: 'user.reviewManage',
				id: 44,
			},
		],
	},
	{
		label: '数据中心',
		id: 8,
		route: 'user.statistics',
	},
	{
		label: '商城',
		id: 9,
		route: 'user.mall',
		children: [
			{
				label: '商品管理',
				id: 50,
			},
			{
				label: '订单',
				id: 51,
				children: [
					{
						label: '订单管理',
						id: 55,
					},
					{
						label: '批量发货',
						id: 56,
					},
					{
						label: '售后服务',
						id: 57,
					},
					{
						label: '批量退款',
						id: 58,
					},
					{
						label: '订单核销',
						id: 59,
					},
					{
						label: '发起退款（包含【订单管理-退款】和【售后服务-处理退款】）',
						id: 67,
					},
				],
			},
			{
				label: '营销',
				id: 52,
			},
			{
				label: '店铺管理',
				id: 53,
			},
			{
				label: '查看商城收益（不可提现）',
				id: 54,
			},
		],
	},
	{
		label: '我的资产',
		id: 10,
		route: 'user.income',
		children: [
			{
				label: '钱包收益（不可提现）',
				id: 60,
				route: 'user.income.profit',
			},
			{
				label: '短信资产',
				id: 61,
				route: 'user.income.sms',
			},
			{
				label: '优惠券',
				id: 62,
				route: 'user.income.coupon',
			},
		],
	},
	{
		label: '订单发票',
		id: 11,
		route: 'user.invoice',
		// children: [
		//     {
		//         label: '订单查询',
		// 		id: 7,
		//     },
		//     {
		//         label: '发票查询与申请',
		// 		id: 7,
		//     },
		// ]
	},
	{
		label: '系统通知',
		id: 12,
		route: 'user.notice',
	},
	{
		label: '企业管理',
		id: 13,
		route: 'companyManage',
		children: [
			{
				label: '子账号设置',
				route: 'user.subaccount',
				id: 63,
			},
			{
				label: '第三方服务接入',
				route: 'user.advanced',
				id: 64,
			},
			{
				label: '品牌及全局设置',
				route: 'user.advanced',
				id: 65,
			},
			{
				label: '操作日志',
				route: 'user.advanced',
				id: 66,
			},
		],
	},
];

export const managerRoles = [
	3, 20, 23, 21, 22, 4, 30, 31, 32, 33, 5, 6, 40, 41, 42, 43, 44, 8, 9, 50, 51, 55, 56, 57, 58, 59, 67, 52, 53, 54,
	12,
];
export const liveManagerRoles = [20];
